import { render } from "./TasksComponent.vue?vue&type=template&id=cef00970&scoped=true"
import script from "./TasksComponent.vue?vue&type=script&lang=js"
export * from "./TasksComponent.vue?vue&type=script&lang=js"

import "./TasksComponent.vue?vue&type=style&index=0&id=cef00970&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef00970"]])

export default __exports__